import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchModel, saveModel } from './thunks';

export type IModelState = {
  model: {
    dataClasses: Record<string, catalog.IDataClass>;
    collections: Record<string, catalog.IDataClass>;
    extraProperties: Record<string, any>;
  };
  draft: {
    dataClasses: Record<string, catalog.IDataClass>;
    collections: Record<string, catalog.IDataClass>;
    extraProperties: Record<string, any>;
  };
  flags: { [key: string]: any };
  errored?: boolean;
};

export const FLAGS_KEYS = {
  DATACLASS_DELETE: 'dataclass.delete',
  DATACLASS_DRAGGABLE: 'dataclass.draggable',
};

const initialState: IModelState = {
  model: {
    dataClasses: {},
    collections: {},
    extraProperties: {},
  },
  draft: {
    dataClasses: {},
    collections: {},
    extraProperties: {},
  },
  flags: {
    [FLAGS_KEYS.DATACLASS_DELETE]: true,
    [FLAGS_KEYS.DATACLASS_DRAGGABLE]: true,
  },
};

const stateSlice = createSlice({
  name: 'Models',
  initialState,
  reducers: {
    setModelFlag(
      state: IModelState,
      action: PayloadAction<{ [key: string]: any }>,
    ) {
      state.flags = {
        ...state.flags,
        ...action.payload,
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchModel.fulfilled, (state, action) => {
      const dataclassesMap: Record<string, catalog.IDataClass> = {};
      const collectionsMap: Record<string, catalog.IDataClass> = {};
      const extraProperties = action.payload.extraProperties || {};

      action.payload.dataClasses?.forEach((dataclass) => {
        dataclassesMap[dataclass.name] = dataclass;
        collectionsMap[dataclass.collectionName] = dataclass;
      });

      state.draft.dataClasses = dataclassesMap;
      state.draft.collections = collectionsMap;
      state.draft.extraProperties = extraProperties;
      state.model.dataClasses = dataclassesMap;
      state.model.collections = collectionsMap;
      state.model.extraProperties = extraProperties;
    });
    builder.addCase(fetchModel.rejected, (state) => {
      state.errored = true;
    });

    builder
      .addCase(saveModel.pending, () => {})
      .addCase(saveModel.fulfilled, (state, action) => {
        const dataclassesMap: Record<string, catalog.IDataClass> = {};
        const collectionsMap: Record<string, catalog.IDataClass> = {};
        const extraProperties = action.payload.content.extraProperties || {};

        action.payload.content.dataClasses.forEach((dataclass) => {
          dataclassesMap[dataclass.name] = dataclass;
          collectionsMap[dataclass.collectionName] = dataclass;
        });

        state.draft.dataClasses = dataclassesMap;
        state.draft.collections = collectionsMap;
        state.draft.extraProperties = extraProperties;
        state.model.dataClasses = dataclassesMap;
        state.model.collections = collectionsMap;
        state.model.extraProperties = extraProperties;
      });
  },
});

// uncomment to export actions from the slice.
export const { setModelFlag } = stateSlice.actions;

export default stateSlice;
